module.exports = __webpack_public_path__ + "static/media/Raullen Chai.0f601cb7.png";